<script>
import { Overlay } from '../../'
import Price from './price.js'
import { EventBus } from '../../EventBus';

export default {
    name: 'MultiTimeframeAnalysis',
    props: [
        'data', 'sub'
    ],
    mixins: [Overlay],
    computed: {
        sett() {
            return this.$props.settings
        },
        price_line() {
            return 'priceLine' in this.sett ?
                this.sett.priceLine : true
        },
        risk_reward_ratio() {
            return this.sett.riskRewardRatio || 3
        },
        show_pending_target() {
            return this.sett.showPendingTarget || true
        },
        show_safe_target() {
            return this.sett.showSafeTarget || false
        },
        show_highlight_entry() {
            return this.sett.showSafeTarget || true
        },
        default_font() {
            return '12px ' + this.$props.font.split('px').pop()
        },
        currency_symbol() {
            return this.sett.currency || '₹'
        },
        long_color() {
            return this.sett.longColor || '#63df89'
        },
        short_color() {
            return this.sett.shortColor || '#ffd581'
        },
        long_cover_color() {
            return this.sett.longCoverColor || '#fc7e2f'
        },
        short_cover_color() {
            return this.sett.shortCoverColor || '#ff6bd6'
        },
        label_color() {
            return this.sett.labelColor || '#4BECF9'
        },
        upBarColor() {
            return this.sett.upBarColor || "rgb(38, 166, 154)"
        },
        downBarColor() {
            return this.sett.downBarColor || "rgb(239, 83, 80)"
        },
        pendingTargetColor() {
            return this.sett.pendingTargetColor || "rgb(92, 92, 92)"
        },
        marker_size() {
            return this.sett.markerSize || 5
        },
        show_label() {
            return this.sett.showLabel !== false
        },
        new_font() {
            return this.sett.font || this.default_font
        }
    },
    methods: {
        meta_info() {
            return {
                author: 'Mano',
                version: '1.0.0',
                desc: 'Multi Timeframe Analysis',
                preset: {
                    name: 'MTA, $smaLength $dcLength $riskRewardRatio',
                    side: 'onchart',
                    settings: {
                        "riskRewardRatio": this.risk_reward_ratio,
                        "showPendingTarget": this.show_pending_target,
                        "showSafeTarget": this.show_safe_target,
                        "showHighlightEntry": this.show_highlight_entry
                    }
                }
            }
        },
        init() {
            this.price = new Price(this)
        },
        draw(ctx) {
            let layout = this.$props.layout
            ctx.lineWidth = 0.5
            ctx.strokeStyle = 'black'

            var data = this.processVTSignals(this.$props.data, {}, true)

            this.$props.data = this.onTimeframeUpdate(data, "minute")

            EventBus.$emit('update:data', this.$props.data);

        },
        onTimeframeUpdate(data, tf) {
            data.className = this.night ? "dark " : ""
            data.label = tf
            data.value = tf
            if (data) {
              var entry = data.entry
              var signal = ""
              var className = ""
              var className1 = ""
              data.timeframe = tf
              if (data && data.length > 0) {
                  const cmp = Number(data[data.length - 1].close);
                  const smaColor = data[data.length - 1].smaColor;
                  const flashtarget = Number(entry.flashTarget);
                  const target = Number(entry.target);

                  if (entry.chartType === "icon-candlestick-vt-laser") {
                      var _latesttrend = Number(entry.latestFlashTrend)

                      if (this.latest_trend) {
                          if (_latesttrend > this.latest_trend) {
                              this.latest_trend = _latesttrend;
                              this.latest_timeframe = data.value;
                          }
                      } else {
                          this.latest_trend = _latesttrend;
                          this.latest_timeframe = data.value;
                      }
                      if (entry.flashSide === "BUY" && cmp < flashtarget) {
                          signal = "⇡"
                          className = "tc-buy";
                      } else if (entry.flashSide === "BUY" && cmp >= flashtarget) {
                          signal = "✓"
                          className = "tc-buy-completed";
                      } else if (entry.flashSide === "SELL" && cmp > flashtarget) {
                          signal = "⇣"
                          className = "tc-sell";
                      } else if (entry.flashSide === "SELL" && cmp <= flashtarget) {
                          signal = "✓"
                          className = "tc-sell-completed";
                      } else {
                          signal = "◦"
                      }

                      if (entry.call === "BUY" && cmp < target && smaColor === "GREEN") {
                          className1 = "tc-shadow-buy";
                      } else if (entry.call === "BUY" && cmp >= target && smaColor === "GREEN") {
                          className1 = "tc-shadow-buy-completed";
                      } else if (entry.call === "SELL" && cmp > target && smaColor === "RED") {
                          className1 = "tc-shadow-sell";
                      } else if (entry.call === "SELL" && cmp <= target && smaColor === "RED") {
                          className1 = "tc-shadow-sell-completed";
                      }

                      var label = data.label.replace("⇡", "").replace("⇣", "").replace("✓", "").replace("◦", "");

                      if (entry.flashActivated) {
                          data.label = signal + label.trim();

                          if (entry.flashSide === "BUY")
                              data.className = "tc-activated-buy" + " " + className1;
                          else if (entry.flashSide === "SELL")
                              data.className = "tc-activated-sell" + " " + className1;
                          else
                              data.className = className + " " + className1;
                      } else {
                          data.className = className + " " + className1;
                          data.label = signal + label.trim();
                      }
                  } else {
                      var _latesttrend = Number(entry.latesttrend)

                      if (this.latest_trend) {
                          if (_latesttrend > this.latest_trend) {
                              this.latest_trend = _latesttrend;
                              //this.latest_timeframe = data.value;
                          }
                      } else {
                          this.latest_trend = _latesttrend;
                          this.latest_timeframe = data.value;
                      }
                      if (entry.call === "BUY" && cmp < target && smaColor === "GREEN") {
                          signal = "⇡"
                          className = "tc-buy";
                      } else if (entry.call === "BUY" && cmp >= target && smaColor === "GREEN") {
                          signal = "✓"
                          className = "tc-buy-completed";
                      } else if (entry.call === "SELL" && cmp > target && smaColor === "RED") {
                          signal = "⇣"
                          className = "tc-sell";
                      } else if (entry.call === "SELL" && cmp <= target && smaColor === "RED") {
                          signal = "✓"
                          className = "tc-sell-completed";
                      } else {
                          signal = "◦"
                      }

                      if (entry.flashSide === "BUY" && cmp < flashtarget) {
                          className1 = "tc-shadow-buy";
                      } else if (entry.flashSide === "BUY" && cmp >= flashtarget) {
                          className1 = "tc-shadow-buy-completed";
                      } else if (entry.flashSide === "SELL" && cmp > flashtarget) {
                          className1 = "tc-shadow-sell";
                      } else if (entry.flashSide === "SELL" && cmp <= flashtarget) {
                          className1 = "tc-shadow-sell-completed";
                      }

                      var label = data.label.replace("⇡", "").replace("⇣", "").replace("✓", "").replace("◦", "");

                      if (entry.activated) {
                          data.label = signal + label.trim();

                          if (entry.call === "BUY")
                              data.className = "tc-activated-buy" + " " + className1;
                          else if (entry.call === "SELL")
                              data.className = "tc-activated-sell" + " " + className1;
                          else
                              data.className = className + " " + className1;
                      } else {
                          data.className = className + " " + className1;
                          data.label = signal + label.trim();
                      }
                  }
              } else {
                  data.className = "p-hidden";
              }
            }

              if (this.latest_timeframe === data.timeframe) {
                  data.className = data.className + " tc-latest-signal";
              }
              return data;
        },

        draw_label(ctx, x, y, labelText) {
            ctx.fillStyle = this.label_color
            ctx.font = this.new_font
            ctx.textAlign = 'center'
            ctx.fillText(labelText, x, y)
        },
        use_for() {
            return ['MultiTimeframeAnalysis']
        },
        processVTSignals(candles, entry, loadTarget) {
            var i = 0, j = 0
            var riskRewardRatio = 3 // this.risk_reward_ratio
            var smaLen = 50 // this.sma_length
            var dcLen = 20 //this.dc_length
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var sma = 0
            var dcHigh = 0
            var dcLow = 0
            var dcMid = 0
            var entryDirection = ""
            var entryPoint = 0
            var entrySL = 0
            var entryTarget = 0
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var activated = false
            var flashActivated = false
            var cmp = candles && candles.length > 0 ? candles[candles.length - 1][4] : 0
            var data = [];
            var startIndex = 0
            var i = 0
            var kuchiSize = 0;

            if (!loadTarget)
                startIndex = candles.length - 30

            for (var p of candles) {
                let tradeTime = p[0]
                let open = p[1]
                let high = p[2]
                let low = p[3]
                let close = p[4]
                var now = { date: tradeTime, open: open, high: high, low: low, close: close }

                now[0] = p[0]
                now[1] = p[1]
                now[2] = p[2]
                now[3] = p[3]
                now[4] = p[4]
                now[5] = p[5]

                if (i >= smaLen) {
                  for (var idx = 0; idx < smaLen; idx++) {
                    var smaIndex = i - idx
                    if (!sma)
                      sma = 0
                    if (smaIndex >= 0)
                      sma = sma + parseFloat(candles[smaIndex][4]) // close price
                    else
                      sma = sma + parseFloat(candles[0][4]) // close price of first candle
                  }

                  sma = parseFloat(sma / smaLen)
                } else {
                  sma = ""
                }

                for (var idx = 0; idx < dcLen; idx++) {
                  var dcIndex = i - idx;
                  if (dcIndex >= 0) {
                    var highPrice = parseFloat(candles[dcIndex][2])
                    if (highPrice > dcHigh)
                      dcHigh = highPrice // high price
                  }
                }

                for (var idx = 0; idx < dcLen; idx++) {
                  var dcIndex = i - idx
                  if (dcIndex >= 0) {
                    var lowPrice = parseFloat(candles[dcIndex][3])
                    if (lowPrice < dcLow)
                      dcLow = lowPrice // low price
                  }
                }

                dcMid = dcLow + Math.abs((dcHigh - dcLow) / 2)
                now.dcHigh = dcHigh
                now.dcLow = dcLow

                now.sma = sma
                if (now.fractalHigh) fractalHigh = now.fractalHigh
                if (now.fractalLow) fractalLow = now.fractalLow

                var candleSize = Math.abs(high - low)
                var bodySize = Math.abs(open - close)

                if (!prev) {
                    prev = now
                    prev.smaColor = ""
                }
                if(now.sma > prev.sma) {
                    now.smaColor = "GREEN"
                } else {
                    now.smaColor = "RED"
                }
                if (!now.tradedVolume) {
                    now.tradedVolume = 0
                }
                if (!now.kuchiSize) {
                    now.kuchiSize = 0
                }
                if (candleSize === 0) {
                    blackCandle = false
                    now.blackCandle = blackCandle
                } else {
                    if(bodySize <= (candleSize / 2)) {
                        blackCandle = true
                        now.blackCandle = blackCandle
                        now.kuchiSize = candleSize - bodySize
                    } else {
                        blackCandle = false
                        now.blackCandle = blackCandle
                    }
                }


                var p_open = Number(prev.open)
                var p_high = Number(prev.high)
                var p_low = Number(prev.low)
                var p_close = Number(prev.close)

                if (prev.blackCandle) {
                    var wick1 = 0
                    var wick2 = 0
                    var wickSize = 0
                    if (p_open > p_close) {
                        wick1 = p_high - p_open
                        wick2 = p_close - p_low
                    } else {
                        wick1 = p_high - p_close
                        wick2 = p_open - p_low
                    }
                    if (wick1 > wick2) {
                        wickSize = wick1
                    } else {
                        wickSize = wick2
                    }
                    if (close >= p_high) {
                        var flashTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_high + Number(wickSize * 1)
                        var flashTarget2 = p_high + Number(wickSize * 2)
                        var flashReverseTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_low - Number(wickSize * 1)
                        var flashReverseTarget2 = p_low - Number(wickSize * 2)
                        now.flashTradeStart = true
                        now.flashTrade = true
                        now.flashSide = "BUY"
                        now.flashEntry = Number(p_high)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_low)
                    } else if (close <= p_low) {
                        var flashTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_low - Number(wickSize * 1)
                        var flashTarget2 = p_low - Number(wickSize * 2)
                        var flashReverseTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_high + Number(wickSize * 1)
                        var flashReverseTarget2 = p_high + Number(wickSize * 2)
                        now.flashTrade = true
                        now.flashTradeStart = true
                        now.flashSide = "SELL"
                        now.flashEntry = Number(p_low)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_high)
                    } else {
                        now.flashTrade = false
                        now.flashTradeStart = false
                        now.flashSide = ""
                        now.flashEntry = 0
                        now.flashTarget = 0
                        now.flashTarget1 = 0
                        now.flashTarget2 = 0
                        now.flashReverseTarget = 0
                        now.flashReverseTarget1 = 0
                        now.flashReverseTarget2 = 0
                        now.flashStoploss = 0
                    }
                }

                if (!now.flashTrade) {
                    now.flashTrade = prev.flashTrade
                    now.flashTradeStart = false
                    now.flashSide = prev.flashSide
                    now.flashTarget = prev.flashTarget
                    now.flashTarget1 = prev.flashTarget1
                    now.flashTarget2 = prev.flashTarget2
                    now.flashReverseTarget = prev.flashReverseTarget
                    now.flashReverseTarget1 = prev.flashReverseTarget1
                    now.flashReverseTarget2 = prev.flashReverseTarget2
                }
                if(now.smaColor === prev.smaColor) {
                    now.trendChanged = false
                } else {
                    trendChanged = true
                    now.trendChanged = trendChanged
                    starFormed = false
                    blackCandleFormed = false
                    entryDirection = ""
                    entryPoint = 0
                    entrySL = 0
                    entryTarget = 0
                }

                if (now.trendChanged != prev.trendChanged) {
                  starFormed = false
                }

                if (prev.blackCandle && now.trendChanged) {
                    starFormed = true
                    blackCandleFormed = true
                    if (now.smaColor === "GREEN") {
                        entryDirection = "BUY"
                        entryPoint = prev.high
                        entrySL = prev.low
                        entryTarget = entryPoint + Number(( entryPoint - entrySL) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    } else {
                        entryDirection = "SELL"
                        entryPoint = prev.low
                        entrySL = prev.high
                        entryTarget = entryPoint - Number(( entrySL - entryPoint ) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    }
                } else {
                    starFormed = false
                }

                if ((starFormed || trendChanged) && now.blackCandle) {
                    blackCandleFormed = true
                    if (now.smaColor === "GREEN") {
                        entryDirection = "BUY"
                        if (entryPoint === 0)
                            entryPoint = high
                        if (entrySL === 0)
                            entrySL = low
                        if (low < entrySL)
                            entrySL = low
                        if (high > entryPoint)
                            entryPoint = high
                        entryTarget = entryPoint + Number(( entryPoint - entrySL) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    } else {
                        entryDirection = "SELL"
                        if (entryPoint === 0)
                            entryPoint = low
                        if (entrySL === 0)
                            entrySL = high
                        if (high > entrySL)
                            entrySL = high
                        if (low < entryPoint)
                            entryPoint = low
                        entryTarget = entryPoint - Number(( entrySL - entryPoint ) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    }
                }

                if ((starFormed || trendChanged) && blackCandleFormed && !now.blackCandle) {
                    trendChanged = false
                    now.isEntry = true
                }

                if (now.isEntry) {
                    //now.trendChanged = trendChanged
                    now.entryDirection = entryDirection
                    now.entryPoint = Number(entryPoint)
                    now.entryStoploss = Number(entrySL)
                    now.entryTarget = Number(entryTarget)

                    if (entry && entryDirection) {
                        var alert = ""
                        entry.call = entryDirection
                        entry.entry = entryPoint
                        entry.stoploss = entrySL
                        entry.target = Number(entryTarget)
                        entry.latesttrend = now.date
                        entry.index = i
                        entry.cmp = cmp
                        entry.tradedVolume = Math.abs(kuchiSize)
                        var targetIndex = candles.length - 10

                        if (entryDirection === "BUY") {
                          if (cmp >= high || high >= now.dcHigh) {
                              alert = "TARGET"
                          } else if (cmp <= now.dcMid || low <= now.dcMid
                              || cmp <= entrySL) {
                              alert = "WARN"
                          } else if (cmp <= now.dcLow || low <= now.dcLow
                              || now.trendChanged) {
                              alert = "STOP"
                          }

                          if ((cmp < entryPoint && cmp > entrySL)
                              || (cmp >= entryPoint && cmp < entryTarget)
                              && ("TARGET" === alert  || alert === "")) {
                              activated = true
                          } else {
                              activated = false
                          }
                        } else if (entryDirection === "SELL") {
                          if (cmp >= now.dcHigh || high >= now.dcHigh || now.trendChanged) {
                              alert = "STOP"
                          } else if (cmp >= now.dcMid || high >= now.dcMid
                              || cmp >= entrySL) {
                              alert = "WARN"
                          } else if (cmp <= now.dcLow || low <= now.dcLow) {
                              alert = "TARGET"
                          }

                          if ((cmp > entryPoint && cmp < entrySL)
                              || (cmp <= entryPoint && cmp > entryTarget)
                              && ("TARGET" === alert  || alert === "")) {
                              activated = true
                          } else {
                              activated = false
                          }
                        }
                    }

                    if (!now.blackCandle) {
                        trendChanged = false
                        blackCandleFormed = false
                        starFormed = false
                        entryDirection = ""
                        entrySL = 0
                        entryPoint = 0
                        entryTarget = 0
                        kuchiSize = 0
                    }
                }

                if (entry.call === "BUY") {
                  if (close >= entry.target || high >= entry.target) {
                    activated = false
                  }
                } else if (entry.call === "SELL") {
                   if (close <= entry.target || low <= entry.target) {
                     activated = false
                   }
                }

                if (now.flashTrade) {
                    entry.flashSide = now.flashSide
                    entry.flashEntry = now.flashEntry
                    entry.flashStoploss = now.flashStoploss
                    entry.flashTarget = Number(now.flashTarget)
                    entry.latestFlashTrend = now.date

                    if (entry.flashSide === "BUY") {
                      if ((close < now.flashEntry && close > now.flashStoploss)
                          || (close >= now.flashEntry && close < now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close >= entry.flashTarget || high >= entry.flashTarget) {
                        flashActivated = false
                      }
                    } else if (entry.flashSide === "SELL") {
                      if ((close > now.flashEntry && close < now.flashStoploss)
                          || (close <= now.flashEntry && close > now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close <= entry.flashTarget || low <= entry.flashTarget) {
                        flashActivated = false
                      }
                    }
                }
                data[i] = now
                prev = now
                i++
            }

            data.entry = entry
            entry.activated = activated
            entry.flashActivated = flashActivated
            return data
        },
        hexToRGBA(inputHex, opacity) {
            const hex = inputHex.replace("#", "")
            if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {

                const multiplier = (hex.length === 3) ? 1 : 2

                const r = parseInt(hex.substring(0, 1 * multiplier), 16)
                const g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16)
                const b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16)

                const result = `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`

                return result
            }
            return inputHex
        }
    }
}
</script>
